import React, { useState,useEffect } from "react";
import { useNavigate, Link ,useLocation} from "react-router-dom";
import axios from "axios";
import { toast } from 'react-toastify';
import { jwtDecode } from "jwt-decode";
import Loader from '../Loader';
// import { useWallet } from '@solana/wallet-adapter-react';
import { Connection, PublicKey,Keypair , Transaction, SystemProgram,clusterApiUrl } from '@solana/web3.js';
import { createTransferInstruction, TOKEN_PROGRAM_ID, getAssociatedTokenAddress } from '@solana/spl-token';
import { Buffer } from 'buffer';
import {
  AnchorProvider,
  Program,
  BN,
  web3,
} from '@project-serum/anchor';
import idl from './idl.json';
import * as anchor from '@project-serum/anchor';
import MemberVerificationPopup from './MemberVerification'
import {
  useDisconnect,
  useAppKit,
  useAppKitNetwork,
  useAppKitAccount,
  useAppKitProvider,
  useAppKitNetworkCore,
} from '@reown/appkit/react';
import { useAppKitConnection } from '@reown/appkit-adapter-solana/react';
import {
  BrowserProvider,
  JsonRpcSigner,
  Contract,
  parseUnits,
  formatEther
} from 'ethers';
import { modal } from '@reown/appkit/react';


import {
  initializeProgram,
  stakeTokens,
  findStakePDA, 
} from '../account-helpers';

window.Buffer = Buffer;

const RIZZ_MINT = new PublicKey('EdG95PrGYHAedgkynvnybwbaR4ErNqAacDkJFCXqEMCS');
const baseUrl = process.env.REACT_APP_API;



export default function RizznetToken() {
  const location = useLocation();

  const [amount, setAmount] = useState(1000);
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_API;
  // const [loading, setLoading] = useState(false);
  const tokenRate = 35; // Assuming 1 USD = 35 RZTO
  const tokensReceived = amount * tokenRate;
const [memberCode, setmemberCode] = useState();
const [selectedDuration, setSelectedDuration] = useState(30); // Default 30 days
const [stakeAmount, setStakeAmount] = useState('');
const [stakingLoading, setStakingLoading] = useState(false);
const [activeStakes, setActiveStakes] = useState([]);
const [walletLoading, setWalletLoading] = useState(false);
const [buyTokenLoading, setBuyTokenLoading] = useState(false);
const [walletAddress, setWalletAddress] = useState('');
const [minTransaction, setMinTransaction] = React.useState(null);
const [isVerified, setIsVerified] = useState({
  email: false,
  wallet: false
});

const [totalStaked, setTotalStaked] = useState(0);


const API_KEY = '7b31436267f41054790dce44ba7bcf7b8b40433ca53ffb425b2ae813582e8577'; 
   
    
const [program, setProgram] = useState(null);
const [stakePDA, setStakePDA] = useState(null);

const { isConnected, address, caipAddress } = useAppKitAccount();
  const { walletProvider: ethProvider } = useAppKitProvider('eip155');
  const { walletProvider: solanaProvider } = useAppKitProvider('solana');
  const { walletProvider: btcProvider } = useAppKitProvider('bip122');
  
const { connection } = useAppKitConnection();
const { disconnect } = useDisconnect();
const [paymentMethod, setPaymentMethod] = useState('');
const [ipAddress, setIpAddress] = useState('');
const { chainId } = useAppKitNetworkCore();


const cryptoLogos = {
  USDT: 'https://assets.coingecko.com/coins/images/325/large/Tether.png',
  USDC: 'https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png',
  ETH: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png',
  SOL: 'https://assets.coingecko.com/coins/images/4128/large/solana.png',
  BNB: 'https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png',
  BTC: 'https://assets.coingecko.com/coins/images/1/large/bitcoin.png',
  LTC: 'https://assets.coingecko.com/coins/images/2/large/litecoin.png',
  DOGE: 'https://assets.coingecko.com/coins/images/5/large/dogecoin.png',
  ADA: 'https://assets.coingecko.com/coins/images/975/large/cardano.png',
  TRC20: 'https://assets.coingecko.com/coins/images/325/large/Tether.png',
  RZTO: 'https://via.placeholder.com/40/4e44ce/FFFFFF?text=RZ' // Placeholder for RZTO
};

  const fetchStaking = async () => {
    if (!memberCode) return;
    setLoading(true);
    const token = sessionStorage.getItem("authToken");

    try {
      const response = await axios.get(`${baseUrl}/api/staking/${memberCode}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });

      if (response.data && response.data.staking) {
        const stakingData = response.data.staking.reverse();

        // ✅ Calculate total staked using Amount field
        const total = stakingData.reduce((sum, stake) => sum + (stake.Amount || 0), 0);
        setTotalStaked(total);
      }
    } catch (error) {
      console.error('Error fetching staking:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaking();
  }, [memberCode]);


const wallet ={};
// const connection = new Connection('https://api.mainnet-beta.solana.com', 'confirmed');
// const connection = new Connection(clusterApiUrl("mainnet-beta"), "confirmed");


const handleVerificationChange = (verificationData) => {
  setIsVerified({
    email: verificationData.IsEmailVerified === 1,
    wallet: !!verificationData.PhantomSolanaAddress
  });
};

useEffect(() => {
  const token = sessionStorage.getItem("authToken");

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const memberCode = decoded.memberCode
      
      // Fetch member details from the API using axios
      axios.get(`${baseUrl}/auth/member/${memberCode}`)
        .then(response => {
          const memberData = response.data;
          setWalletAddress(memberData.walletAddress);
        })
        .catch(error => {
          console.error("Error fetching member data", error);
          toast.error('Error fetching member data!');
        });
    } catch (error) {
      console.error("Invalid token", error);
    }
  }
}, []);


  const handleConnect = async () => {
    try {
      if (connected) {
        await disconnect();
      } else {
        modal.open('solana');
      }
    } catch (err) {
      console.error('Connection error:', err);
    }
  };


const disconnectPhantomWallet = async (e) => {
  e.preventDefault();
  try {
    if (wallet.connected) {
      await wallet.disconnect();
      toast.success('Disconnected from wallet successfully.');
      setPurchasedTokens(0);
    }
  } catch (err) {
    console.error('Wallet disconnection failed', err);
    toast.error('Failed to disconnect wallet.');
  }
};


// Calculate stake progress percentage
const calculateStakeProgress = (startTime, endTime) => {
  const now = Math.floor(Date.now() / 1000);
  if (now >= endTime) return 100;
  if (now <= startTime) return 0;
  
  const totalDuration = endTime - startTime;
  const elapsed = now - startTime;
  return Math.min(100, Math.round((elapsed / totalDuration) * 100));
};

// Calculate current rewards for a stake
const calculateCurrentRewards = (stake) => {
  const now = Math.floor(Date.now() / 1000);
  const effectiveTime = Math.min(now, stake.endTime);
  
  if (effectiveTime <= stake.startTime) return 0;
  
  const totalStakingPeriod = stake.endTime - stake.startTime;
  const timeElapsed = effectiveTime - stake.startTime;
  const fractionComplete = timeElapsed / totalStakingPeriod;
  
  const rewardRateDecimal = stake.rewardRate / 10000;
  const reward = stake.amount * rewardRateDecimal * fractionComplete;
  
  return Math.floor(reward * 100) / 100; // Return with 2 decimal places
};

// Add these functions to your component
const calculateEstimatedRewards = (amount, durationDays) => {
  if (!amount || amount <= 0) return '0';
  
  const amountNum = parseFloat(amount);
  const apy = getRewardRate(durationDays) / 100; // Convert to decimal
  
  // Calculate estimated rewards (simple calculation)
  const rewards = amountNum * apy * (durationDays / 365);
  return rewards.toFixed(6);
};

const handleStake = async () => {
  const stakeAmt = parseFloat(String(stakeAmount).trim());

  
  try {
    setStakingLoading(true);
    
    // Ensure Phantom is available
    const provider = window.solana;
    if (!provider || !provider.isPhantom) {
      throw new Error('Phantom Wallet not found');
    }

    // Ensure connected
    if (!provider.isConnected) {
      await provider.connect();
    }
    const walletPublicKey = provider.publicKey.toString();

    const rizzAmt = parseFloat(String(rizztoken).trim());

   if (walletAddress !== walletPublicKey) {
   toast.warning('You have connected a different wallet. Please connect with the same wallet you used during registration.');
   return;
   }


  if (!stakeAmt || rizzAmt < 50) {
    toast.warning('Minimum stake amount is 50 RZTO');
    return;
  }

  if (stakeAmt > rizzAmt) {
    toast.warning('You don\'t have enough RZTO to stake');
    return;
  }
    // Get unsigned transaction from backend
    const response = await fetch(`${BaseUrl}/api/stakes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userPublicKey: walletPublicKey,
        amount: stakeAmt,
        lockDays: selectedDuration,
      }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to initiate stake');

    // Deserialize the transaction
    const transaction = anchor.web3.Transaction.from(
      Buffer.from(data.tx, 'base64')
    );


    // Request wallet to sign
    const signed = await provider.signTransaction(transaction);
    

    if (signed.signatures.length === 0) {
      throw new Error('No signatures were added to the transaction');
    }

    // Serialize the signed transaction
    const serializedSignedTx = signed.serialize();

    const rewards = calculateEstimatedRewards(stakeAmt, selectedDuration)

    const metadata = {
        type: 'stake',        
        memberCode: `${memberCode}`,   
        amount: stakeAmt,          
        lockDays: selectedDuration,  
        rewards: rewards       
        };

    // Send to backend for confirmation
    const confirmResponse = await fetch(`${BaseUrl}/api/confirmTransaction`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        signedTx: Buffer.from(serializedSignedTx).toString('base64'),
        metadata
      }),
    });

    const confirmData = await confirmResponse.json();
    if (!confirmResponse.ok) {
      throw new Error(confirmData.error || 'Failed to confirm stake');
    }

    toast.success(`Token staked successfully!`);
    navigate('/token/staking');
    // Update UI state
    // const newStake = {
    //   amount: stakeAmt,
    //   startTime: Math.floor(Date.now() / 1000),
    //   endTime: Math.floor(Date.now() / 1000) + selectedDuration * 24 * 60 * 60,
    //   duration: selectedDuration,
    //   rewardRate: getRewardRate(selectedDuration),
    //   txHash: confirmData.txId,
    // };
    // setActiveStakes([...activeStakes, newStake]);
    setStakeAmount('');

  } catch (error) {
    console.error('Detailed staking error:', {
      error: error.message,
      stack: error.stack,
      response: error.response?.data
    });
    toast.error(error.message || 'Staking failed. See console for details.');
  } finally {
    setStakingLoading(false);
  }
};



const getRewardRate = (duration) => {
  // These should match what's in your program
  if (duration <= 30) return 8; // 8%
  if (duration <= 90) return 10; // 10%
  if (duration <= 180) return 12; // 12%
  return 15; // 15%
};


        const decodeToken = (token) => {
          try {
            const decoded = jwtDecode(token);
            return decoded.memberCode || null;
          } catch (error) {
            console.error("Invalid token:", error);
            return null;
          }
        };
      useEffect(() => {
        const token = sessionStorage.getItem("authToken");
        const memberCode = decodeToken(token);
        setmemberCode(memberCode);
   
    }, []);


   useEffect(() => {
         const token = sessionStorage.getItem('authToken');
         if (!token) {
           navigate('/token/signin');
           return;
         }
       
         const validateToken = async () => {
           try {
             const response = await fetch(`${baseUrl}/validate-token`, {
               method: 'POST',
               headers: {
                 'Content-Type': 'application/json',
               },
               body: JSON.stringify({ token }),
             });
       
             const data = await response.json();
       
             if (!data.valid) {
               sessionStorage.removeItem('authToken'); // Optional cleanup
               navigate('/token/signin');
             }
           } catch (error) {
             console.error('Token validation failed:', error);
             sessionStorage.removeItem('authToken');
             navigate('/token/signin');
           }
         };
       
         validateToken();
       }, [navigate]);

  
  
     const [isModalOpen, setIsModalOpen] = useState(false);
     const [connected, setConnected] = useState(false);
     const [selectedPayment, setSelectedPayment] = useState('');
     const [selectedReceive, setSelectedReceive] = useState('RZTO');
     const [paymentAmount, setPaymentAmount] = useState('');
     const [timeLeft, setTimeLeft] = useState({
       days: 8,
       hours: 0,
       minutes: 29,
       seconds: 14
     });
   
     const receiveOptions = ['ETH', 'BNB', 'SOL', 'RZTO'];
   
     const [walletConnected, setWalletConnected] = useState(false);
     const [userPublicKey, setUserPublicKey] = useState(null);
     
     const [exchangeRates, setExchangeRates] = useState({});
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState(null);
   
     const [rizztoken,setPurchasedTokens] =  useState(0); 

 const [promoCode, setPromoCode] = useState('');
const [discountAmount, setDiscountAmount] = useState(0);
const [promoError, setPromoError] = useState('');
const [promoSuccess, setPromoSuccess] = useState('');
const [extraToken, setExtraToken] = useState(0);
const [appliedPromo, setAppliedPromo] = useState(null);
const [discountedAmount, setDiscountedAmount] = useState(parseFloat(paymentAmount));
const [showProcessingPopup, setShowProcessingPopup] = useState(false);



const [qrCode, setQrCode] = useState('');
const [paymentAddress, setPaymentAddress] = useState('');
const [showPaymentModal, setShowPaymentModal] = useState(false);

const [remainingTime, setRemainingTime] = useState(600); 
const [invoiceId, setInvoiceID] = useState('');
const [currency, setCurrency] = useState('');
const [rztoAmount,setRZTOAmount] = useState('');

 const [copied, setCopied] = useState(false);
  const [copiedAddress, setCopiedAddress] = useState(false);
  const [status, setStatus] = useState('⏳ Waiting');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
       if (!invoiceId) return;
      try {
        const response = await axios.get(`${BaseUrl}/api/payment/status?invoice_id=${invoiceId}`);
        const data = response.data;

        if (data?.success && data.status === 'completed' && data.transaction?.Status === 'Completed') {
          setStatus('✅ Completed');
          // toast.success('Transaction successfully completed');
          navigate('/token/payment/sucess');
          setChecking(false);

          setTimeout(() => {
            navigate('/token/transactions'); 
          }, 2000);
        }
      } catch (error) {
        // console.error('Error checking payment status:', error);
      }
    };

    const interval = setInterval(() => {
      if (checking) {
        checkStatus();
      }
    }, 5000); 

    return () => clearInterval(interval); 
  }, [invoiceId, checking, navigate]);


  const handleCopy = () => {
    navigator.clipboard.writeText(paymentAmount.toString());
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
    const handleCopyAddress = () => {
    navigator.clipboard.writeText(paymentAddress.toString());
    setCopiedAddress(true);
    setTimeout(() => setCopiedAddress(false), 1500);
  };

  // const closeModal = () => {
  //   setShowProcessingPopup(true);
  //   setShowPaymentModal(false);
    
  //   setTimeout(() => {
  //     setShowProcessingPopup(false);
  //     setRemainingTime(600);
  //     setInvoiceID('');
  //     navigate('/token/transactions');
  //   }, 5000);
  // };

const closeModal = () => { 
  if (invoiceId) {
    navigate(`/token/payment/status?invoice_id=${invoiceId}`);
  } else {
    // Fallback in case invoiceId is missing (shouldn't happen)
    setTimeout(() => {
      setShowProcessingPopup(false);
      navigate('/token/transactions');
    }, 5000);
  }
};

 const closeCancelModal = () => {
     setShowPaymentModal(false);
      setRemainingTime(600);
      setInvoiceID('');
  }; 

const handleCancelTransaction = async ( ) => {
  try {
     const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${baseUrl}/api/payment/cancel`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ 
        invoice_id: invoiceId,
        status: "Canceled" 
      }),
    });

    if (response.ok) {
      closeCancelModal();
      // toast.error('Your transaction is cancelled');
      navigate('/token/payment/failed');
      setTimeout(() => {
        navigate('/token/transactions');
      }, 30000);
      setRemainingTime(600); 
    } else {
      console.error('Failed to cancel transaction');
    }
  } catch (error) {
    console.error('Error canceling transaction:', error);
  }
};


useEffect(() => {
  const interval = setInterval(() => {
    setRemainingTime(prev => {
      if (prev <= 1) {
        clearInterval(interval);
       closeModal();
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  return () => clearInterval(interval); 
}, []);

const formatsTime = (seconds) => {
  const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return `${mins}:${secs}`;
};



// Add this useEffect to reset promo when amount or payment changes
useEffect(() => {
  if (paymentAmount || selectedPayment) {
    setPromoCode('');
    setPromoError('');
    setPromoSuccess('');
    setDiscountAmount(0);
    setExtraToken(0);
    setAppliedPromo(null);
    setDiscountedAmount(parseFloat(paymentAmount));
  }
}, [paymentAmount, selectedPayment]);

const applyPromoCode = async () => {
  try {
    setPromoError('');
    setPromoSuccess('');
    setDiscountAmount(0);
    setExtraToken(0);

    const token = sessionStorage.getItem("authToken");
    const usdAmount = selectedPayment === 'USDT' 
      ? parseFloat(paymentAmount) 
      : calculateUsdtEquivalent();

    if (!usdAmount || usdAmount <= 0) {
      const errorMsg = 'Enter a valid amount to apply promo code.';
      setPromoError(errorMsg);
      toast.warning(errorMsg);
      return;
    }

    const response = await axios.post(
      `${BaseUrl}/api/promo-codes/apply-promo`,
      {
        promoCode: promoCode,
        RizzAmount: calculateReceivedAmount()
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.status === 200 && response.data) {
      const { message, discount_type, discount_value, code, extraTokens } = response.data;
      toast.success(message);

      setAppliedPromo({
        discount_type,
        discount_value,
        code,
      });

      setExtraToken(extraTokens || 0);

      let calculatedDiscount = 0;
      let discountedAmount = parseFloat(paymentAmount);

      if (discount_type === 'percentage') {
        calculatedDiscount = (discountedAmount * discount_value) / 100;
        discountedAmount -= calculatedDiscount;
      } else if (discount_type === 'flat') {
        calculatedDiscount = discount_value;
        discountedAmount -= calculatedDiscount;
      }

      setDiscountAmount(calculatedDiscount);
      setDiscountedAmount(discountedAmount);
      setPromoSuccess(
        `Promo code ${code} applied! You will receive ${extraTokens} bonus tokens.`
      );
    }
  } catch (error) {
    console.error('Promo code error:', error);
    if (error.response?.status === 404) {
      toast.error(error.response.data.error || 'Promo code not found');
    } else {
      toast.error('Invalid promo code');
    }

    setPromoError('Invalid or expired promo code');
    setAppliedPromo(null);
    setDiscountAmount(0);
    setDiscountedAmount(0);
    setExtraToken(0);
  }
};
      



// const handlePayment = async (e) => {
//   e.preventDefault();

//   const amountParsed = parseFloat(paymentAmount);
//   const tokenParsed = parseFloat(extraToken);
  
//   if(!selectedPayment){
//     toast.warning("Please Select Payment Currency ");
//     return;
//   }

//   if (!amountParsed || isNaN(amountParsed)) {
//     toast.warning("Please enter an amount.");
//     return;
//   }
   

//   const usdtAmount = selectedPayment === 'USDT' 
//     ? parseFloat(paymentAmount) 
//     : calculateUsdtEquivalent(); // assume this function converts to USDT equivalent

//   // if (usdtAmount < 25) {
//   //   toast.warning("Amount must be at least $25");
//   //   return;
//   // }
//   // ✅ Additional check for minTransaction
//   if (minTransaction && amountParsed < parseFloat(minTransaction)) {
//     toast.warning(`Amount must be at least ${minTransaction} ${selectedPayment}`);
//     return;
//   }
//   setBuyTokenLoading(true);

//   try {
//     const paymentPayload = {
//       memberCode: `${memberCode}`,  
//       amount: usdtAmount,
//       currencyAmount: paymentAmount,
//       promoCode:promoCode,
//       extraToken:tokenParsed,
//       currency: selectedPayment,
//       callback_url: `${BaseUrl}/api/payment/callback`
//     };

//     const response = await axios.post(`${BaseUrl}/api/payment/create-payment`, paymentPayload);
//     const data = response.data;


//     if (data && data.qr_code_url && data.payment_address) {
//       // toast.success("Payment initiated successfully!");
//       setInvoiceID(data.invoiceId);
//       setCurrency(data.currency);
//       setPaymentAmount(data.currencyAmount)
//       setRZTOAmount(data.rztoAmount);
//       setQrCode(data.qr_code_url); 
//       setPaymentAddress(data.payment_address);
//       setShowPaymentModal(true);
//     } else {
//       toast.error("Invalid response from payment gateway.");
//     }

//   } catch (error) {
//     console.error("Payment Error:", error);
//     toast.error("Payment failed, please try again.");
//   } finally {
//     setBuyTokenLoading(false);
//   }
// };

const getEthSigner = () => {
  if (!ethProvider || !address) throw new Error("Ethereum wallet not connected.");
  const provider = new BrowserProvider(ethProvider, chainId);
  return new JsonRpcSigner(provider, address);
};

const handleError = (err, context = "Transaction") => {
  console.error(`${context} Error:`, err);

  if (err?.code === 4001 || err?.message?.toLowerCase().includes("user rejected")) {
    toast.error("Transaction rejected by user.");
  } else if (
    err?.message?.toLowerCase().includes("insufficient funds") ||
    err?.message?.toLowerCase().includes("insufficient balance")
  ) {
    toast.error("Insufficient balance to complete the transaction.");
  } else {
    toast.error(`${context} failed. Please try again.`);
  }
};

const handlePayment = async (e) => {
  e.preventDefault();

  if (!paymentMethod) {
    toast.error("Please select payment method.");
    return;
  }

  if (!paymentAmount) {
    toast.error("Please enter valid amount.");
    return;
  }

  try {
    setBuyTokenLoading(true);

    const usdtAmount = selectedPayment === 'USDT'
      ? parseFloat(paymentAmount)
      : calculateUsdtEquivalent();

    const tokenParsed = parseFloat(extraToken);

    const payload = {
      walletAddress: address,
      amount: usdtAmount,
      promoCode: promoCode || undefined,
      extraToken: tokenParsed || undefined,
      currencyAmount: paymentAmount,
      currency: selectedPayment.toLowerCase(),
      ipAddress: ipAddress || undefined
    };

    const cleanPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v !== undefined)
    );

    // SOL PAYMENT
    if (paymentMethod === 'sol') {
      if(!solanaProvider){
        toast.error('Please Solana-compatible wallet');
        return;
      }

      const response = await axios.post(`${baseUrl}/api/quick-payment/process-sol-payment`, cleanPayload);
      if (!response.data.transaction) throw new Error('Failed to prepare SOL transaction');

      const transaction = Transaction.from(Buffer.from(response.data.transaction, 'base64'));
      const signedTx = await solanaProvider.signTransaction(transaction);
      const signature = await connection.sendRawTransaction(signedTx.serialize());
      await connection.confirmTransaction(signature, 'confirmed');

      const confirmResponse = await axios.post(
        `${baseUrl}/api/quick-payment/confirm-sol-payment`,
        { ...cleanPayload, txSignature: signature }
      );

      if (confirmResponse.data.success) {
        // Redirect to success page with query params
        navigate(`/token/payment/success?amount=${paymentAmount}&currency=${selectedPayment}&tx=${signature}`);
        return;
      }
    }

    // ETH/USDT/USDC PAYMENT
    if (['eth', 'usdt', 'usdc'].includes(paymentMethod)) {
      if(!ethProvider){
        toast.error('Please Ethereum-compatible wallet');
        return;
      }
      
      const { data } = await axios.post(
        `${baseUrl}/api/quick-payment/process-eth-payment`,
        cleanPayload
      );

      if (paymentMethod === 'eth') {
        const txParams = {
          to: data.to,
          value: data.value || 0,
          data: data.data || '0x',
          gasLimit: 21000
        };

        const signer = getEthSigner();
        const tx = await signer.sendTransaction(txParams);
        const txHash = tx.hash;

        // Confirm on backend
        const confirm = await axios.post(
          `${baseUrl}/api/quick-payment/confirm-eth-payment`,
          { ...cleanPayload, txHash }
        );

        if (confirm.data.success) {
          // Redirect to success page
          navigate(`/token/payment/success?amount=${paymentAmount}&currency=${selectedPayment}&tx=${txHash}`);
          return;
        }
      }

      // For USDT/USDC
      const txParams = {
        from: address,
        to: data.to,
        value: data.value,
        data: data.data
      };

      const txHash = await ethProvider.request({
        method: 'eth_sendTransaction',
        params: [txParams]
      });

      const confirm = await axios.post(
        `${baseUrl}/api/quick-payment/confirm-eth-payment`,
        { ...cleanPayload, txHash }
      );

      if (confirm.data.success) {
        navigate(`/token/payment/success?amount=${paymentAmount}&currency=${selectedPayment}&tx=${txHash}`);
        return;
      }
    }

    // Default payment method
    // if(!solanaProvider){
    //   toast.error('Please connect solana wallet');
    //   return;
    // }
      const amountParsed = parseFloat(paymentAmount);

      if (minTransaction && amountParsed < parseFloat(minTransaction)) {
        toast.warning(`Amount must be at least ${minTransaction} ${selectedPayment}`);
        return;
      }

      const paymentPayload = {
      memberCode: `${memberCode}`,  
      amount: usdtAmount,
      currencyAmount: paymentAmount,
      promoCode:promoCode,
      extraToken:tokenParsed,
      currency: selectedPayment,
      callback_url: `${BaseUrl}/api/payment/callback`
    };
      const response = await axios.post(
      `${BaseUrl}/api/payment/create-payment`,
      { 
        ...paymentPayload, 
        success_url: `${window.location.origin}/token/payment/success`,
        cancel_url: `${window.location.origin}/token/payment/failed`
      }
    );

    const { data } = response;
    if (data?.qr_code_url && data?.payment_address) {
      setInvoiceID(data.invoiceId);
      setCurrency(data.currency);
      setPaymentAmount(data.currencyAmount);
      setRZTOAmount(data.rztoAmount);
      setQrCode(data.qr_code_url);
      setPaymentAddress(data.payment_address);
      setShowPaymentModal(true);
    }

  } catch (error) {
    console.error("Payment error:", error);
    // Redirect to failure page
    navigate('/token/payment/failed', {
      state: { 
        error: error.message,
        amount: paymentAmount,
        currency: selectedPayment
      }
    });
  } finally {
    setBuyTokenLoading(false);
  }
};

React.useEffect(() => {
  if (!selectedPayment) {
    setMinTransaction(null);
    return;
  }
    const symbolMap = {
      USDT: 'usdt',
      USDC: 'usdc',
      BTC: 'btc',
      ETH: 'eth',
      BNB: 'bnb',
      LTC: 'ltc',
      DOGE: 'doge',
      ADA: 'ada',
      SOL: 'sol',
      RZTO: 'rzto',
    };

  const symbol = symbolMap[selectedPayment] || selectedPayment.toLowerCase();

  fetch(`${BaseUrl}/api/payment/min-transaction/${symbol}`)
    .then((res) => res.json())
    .then((data) => {
      if (data.minimum_transaction_coin) {
        setMinTransaction(data.minimum_transaction_coin);
      } else {
        setMinTransaction(null);
      }
    })
    .catch(() => setMinTransaction(null));
}, [selectedPayment]);



    useEffect(() => {
      const setup = async () => {
        if (!wallet.publicKey) return;
        const { program, programId } = await initializeProgram(connection, wallet);
    
        const [pda] = await findStakePDA(programId, wallet.publicKey); // ✅ just get PublicKey
        setProgram(program);
        setStakePDA(pda); // ✅ store only PublicKey
      };
    
      setup();
    }, [wallet.publicKey]);
    
   
   

  const fetchPurchasedRizzTokens = async (walletAddress) => {
    if (!walletAddress) {
      setPurchasedTokens("0");
      return;
    }
  
    setLoading(true);
  
    try {
      const response = await fetch(`${BaseUrl}/api/token-balance?account=${walletAddress}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
  
      // Assume the response is in the form: { balance: <number> }
      const uiAmount = parseFloat(data.balance) || 0;
      setPurchasedTokens(uiAmount.toFixed(4));
  
    } catch (error) {
      setPurchasedTokens("0");
    } finally {
      setLoading(false);
    }
  };
  
  
  // Call the fetch function when the component mounts or when walletAddress changes
  useEffect(() => {
    if (walletAddress) {
      fetchPurchasedRizzTokens(walletAddress);
    } else {
      setPurchasedTokens("0"); // Reset if wallet disconnects
    }
  }, [walletAddress]);
  
      
     const handleBuyRizz = async () => {

       setLoading(true);
      //  if (!wallet?.publicKey) {
      //    toast.warning('Connect your wallet first.');
      //    return;
      //  }
     
       try {
         const amount = parseFloat(paymentAmount);
         const paymentRate = exchangeRates[selectedPayment] || 0;
         const usdtValue = amount * paymentRate;
         const rizzRate = exchangeRates['RZTO'] || 0;
     
         const rizzAmount = rizzRate > 0 ? usdtValue / rizzRate : 0;
     
         if (rizzAmount <= 0) {
           toast.warning('Invalid payment amount or rate.');
           return;
         }
     
         const response = await axios.post(`${BaseUrl}/api/buy-rizz`, {
           buyer: wallet.publicKey.toBase58(),
           rizzAmount: rizzAmount.toFixed(6), // send it with precision
           paymentToken: selectedPayment,
           usdtValue: usdtValue.toFixed(2),
         });
     
         if (response.data?.txId) {
           toast.success(`RZTO bought! Tx: ${response.data.txId}`);
         } else {
           toast.error('Transaction failed.');
         }
         setLoading(false);
         fetchPurchasedRizzTokens();
       } catch (err) {
         console.error('Buy Rizz failed', err);
         toast.error('Transaction failed.');
         setLoading(false);
   
       }
     };

     
  useEffect(() => {
    const fetchRates = async () => {
      try {
        setLoading(true);
        const response = await axios.get('https://min-api.cryptocompare.com/data/pricemulti', {
          params: {
            fsyms: 'BTC,ETH,ARB,POL,USDT,USDC,BNB,LTC,DOGE,ADA,SOL,TRX,TRC20',
            tsyms: 'USDT',
          },
          headers: {
            authorization: `Apikey ${API_KEY}`,
          },
        });

        const data = response.data;
        const updatedRates = {
          TRC20: 1,
          USDT: 1,
          USDC: data.USDC?.USDT || 1,
          BTC: data.BTC?.USDT,
          ETH: data.ETH?.USDT,
          ARB: data.ARB?.USDT,
          POL: data.POL?.USDT,
          BNB: data.BNB?.USDT,
          LTC: data.LTC?.USDT,
          DOGE: data.DOGE?.USDT,
          SOL: data.SOL?.USDT,
          RZTO: 0.0040,
        };

        setExchangeRates(updatedRates);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error('Error fetching rates:', err);
      }
    };

    fetchRates();
    const interval = setInterval(fetchRates, 60000);
    return () => clearInterval(interval);
  }, []);

   
     // Timer countdown
     useEffect(() => {
       const timer = setInterval(() => {
         setTimeLeft(prevTime => {
           const { days, hours, minutes, seconds } = prevTime;
           
           let newSeconds = seconds - 1;
           let newMinutes = minutes;
           let newHours = hours;
           let newDays = days;
           
           if (newSeconds < 0) {
             newSeconds = 59;
             newMinutes -= 1;
           }
           
           if (newMinutes < 0) {
             newMinutes = 59;
             newHours -= 1;
           }
           
           if (newHours < 0) {
             newHours = 23;
             newDays -= 1;
           }
           
           if (newDays <= 0 && newHours <= 0 && newMinutes <= 0 && newSeconds <= 0) {
             clearInterval(timer);
             return { days: 0, hours: 0, minutes: 0, seconds: 0 };
           }
           
           return { 
             days: newDays, 
             hours: newHours, 
             minutes: newMinutes, 
             seconds: newSeconds 
           };
         });
       }, 1000);
   
       return () => clearInterval(timer);
     }, []);
   

   
       const connectPhantomWallet = async (e) => {
         e.preventDefault();
         setWalletLoading(true);
         try {
           if (!wallet.connected) {
             const selected = wallet.wallets[0];
             if (selected) {
               await wallet.select(selected.adapter.name);
               await wallet.connect();
               toast.success('Initiating wallet connection.');
              } else {
               toast.warning('No wallet found.');
             }
           }
          } catch (err) {
            console.error('Wallet connection failed', err);
            toast.error('Failed to connect wallet.');
          } finally {
            setWalletLoading(false); 
          }
       };
   
     const handlePaymentAmountChange = (e) => {
       const value = e.target.value;
       if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
         setPaymentAmount(value);
       }
     };
   
     const calculateReceivedAmount = () => {
       if (!paymentAmount || isNaN(paymentAmount)) return '0';
       
       const amount = parseFloat(paymentAmount);
       if (amount <= 0) return '0';
     
       try {
         // Convert payment amount to USDT equivalent
         const paymentRate = exchangeRates[selectedPayment] || 0;
         const usdtValue = amount * paymentRate;
     
         // Convert USDT to receive token
         const receiveRate = exchangeRates[selectedReceive] || 0;
         const receivedAmount = receiveRate > 0 ? usdtValue / receiveRate : 0;
     
         // Format based on token type
         if (selectedReceive === 'RZTO') {
           return receivedAmount.toLocaleString(undefined, {
             maximumFractionDigits: 2,
             minimumFractionDigits: 2
           });
         }
         return receivedAmount.toLocaleString(undefined, {
           maximumFractionDigits: 6,
           minimumFractionDigits: 2
         });
       } catch (err) {
         console.error('Calculation error:', err);
         return '0';
       }
     };
   
     const formatTime = (value) => {
       return value < 10 ? `0${value}` : value;
     };
   
     if (loading && !Object.values(exchangeRates).some(rate => rate > 0)) {
       return <div ><Loader/></div>;
     }
   
     if (error) {
       return <div className="wizard-container error">{error}</div>;
     }

     const calculateUsdtEquivalent = () => {
      if (!paymentAmount || isNaN(parseFloat(paymentAmount))) return 0;
      
      const amount = parseFloat(paymentAmount);
      
      switch(selectedPayment) {
        case 'BTC':
          return amount * exchangeRates.BTC;
        case 'ETH':
          return amount * exchangeRates.ETH;
        case 'ARB': 
          return amount * (exchangeRates.ARB || 0);
        case 'POL':
          return amount * (exchangeRates.POL || 0);
        case 'SOL':
          return amount * exchangeRates.SOL;
        case 'BNB':
        return amount * exchangeRates.BNB;
        case 'LTC':
        return amount * exchangeRates.LTC;
        case 'DOGE':
        return amount * exchangeRates.DOGE;
        default:
          return amount; 
      }
    };


  return (
    <>
    <MemberVerificationPopup 
      memberCode={memberCode} 
      onVerificationChange={handleVerificationChange} 
    />
    <div
    style={{
      backgroundImage: `url(/images/main-background.jpg)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: "100vh",
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: -1,
      filter: "blur(10px)",
    }}
  ></div>

  {showProcessingPopup && (
    <div className="processing-notification">
      <div className="processing-content">
        <div className="loader"></div>
        <h3>Transaction Processing</h3>
        <p>On success, RZTO tokens will be credited to your Solana wallet within 5-10 minutes</p>
      </div>
    </div>
  )}
   
{!isModalOpen && (
  <div className="checkout-wrapper">
    <div className="checkout-container">
      <div className="token-balance-card">
        <h2>Your Balance</h2>
        <h1 className="token-amount">{Number(rizztoken).toLocaleString()} RZTO</h1>
      </div>

      {rizztoken > 50 ? (
        <div className="staking-card">
          <h2 className="staking-title">Stake Tokens</h2>
          
          <div className="apy-selector">
            <h3 className="apy-heading">Choose APY Timeline</h3>
            <div className="apy-options">
              <label className="apy-option">
                <input 
                  type="radio" 
                  name="duration" 
                  value="30" 
                  defaultChecked 
                  onChange={(e) => setSelectedDuration(Number(e.target.value))}
                />
                <div className="apy-box">
                  <span className="apy-days">30 Days</span>
                  <span className="apy-percent">8.0% APY</span>
                </div>
              </label>
              <label className="apy-option">
                <input 
                  type="radio" 
                  name="duration" 
                  value="90" 
                  onChange={(e) => setSelectedDuration(Number(e.target.value))}
                />
                <div className="apy-box">
                  <span className="apy-days">90 Days</span>
                  <span className="apy-percent">10.0% APY</span>
                </div>
              </label>
              <label className="apy-option">
                <input 
                  type="radio" 
                  name="duration" 
                  value="180" 
                  onChange={(e) => setSelectedDuration(Number(e.target.value))}
                />
                <div className="apy-box">
                  <span className="apy-days">180 Days</span>
                  <span className="apy-percent">12.0% APY</span>
                </div>
              </label>
              <label className="apy-option">
                <input 
                  type="radio" 
                  name="duration" 
                  value="365" 
                  onChange={(e) => setSelectedDuration(Number(e.target.value))}
                />
                <div className="apy-box">
                  <span className="apy-days">365 Days</span>
                  <span className="apy-percent">15.0% APY</span>
                </div>
              </label>
            </div>
          </div>

          <div className="stake-amount-input">
            <label htmlFor="stakeAmount">Amount to Stake (RZTO)</label>
            <input
              type="number"
              id="stakeAmount"
              min="50"
              max={rizztoken}
              value={stakeAmount}
              onChange={(e) => setStakeAmount(e.target.value)}
              placeholder="Enter amount"
            />
          </div>

          <div className="reward-estimate">
            <h4>Estimated Rewards</h4>
            <p>{calculateEstimatedRewards(stakeAmount, selectedDuration)} RZTO</p>
          </div>
          
          <button 
            className="buy-token-button"
            onClick={handleStake}
            //  disabled={!stakeAmount || stakeAmount < 50 || stakeAmount > rizztoken}
          >
            {stakingLoading ? (
              <>
                Processing...
                <div className="spinner"></div>
              </>
            ) : (
              <>
                Stake Tokens
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </>
            )}
          </button>
          
          <p className="info-note">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Verify transaction from wallet after staking
          </p>

          <button onClick={(e) => {
              e.preventDefault();
            if (!isVerified.email) {
              toast.warning("Email not verified. Please verify your email");
              navigate('/token/verify-email');
              return;
            }
            if (!isVerified.wallet) {
              toast.warning("Wallet not connected. Please connect your wallet.");
              navigate('/token/connect-wallet');
              return;
            }
            setIsModalOpen(true);
          }}
         className="buy-token-button">
            Buy Token
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 6V12M12 12V18M12 12H18M12 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          {/* Active Stakes Section */}
          {activeStakes.length > 0 && (
            <div className="active-stakes">
              <h3>Your Active Stakes</h3>
              <div className="stakes-list">
                {activeStakes.map((stake, index) => (
                  <div key={index} className="stake-item">
                    <div className="stake-details">
                      <span className="stake-amount">{stake.amount} RZTO</span>
                      <span className="stake-duration">{stake.duration} days</span>
                    </div>
                    <div className="stake-progress">
                      <div 
                        className="progress-bar" 
                        style={{
                          width: `${calculateStakeProgress(stake.startTime, stake.endTime)}%`
                        }}
                      ></div>
                      <span className="stake-apy">{stake.rewardRate / 100}% APY</span>
                    </div>
                    <div className="stake-time">
                      <span>
                        Ends: {new Date(stake.endTime * 1000).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
        <button onClick={(e) => {
           e.preventDefault();
            if (!isVerified.email) {
              toast.warning("Email not verified. Please verify your email");
              navigate('/token/verify-email');
              return;
            }
            if (!isVerified.wallet) {
              toast.warning("Wallet not connected. Please connect your wallet");
              navigate('/token/connect-wallet');
              return;
            }
            setIsModalOpen(true);
          }} className="buy-token-button">
          Buy Token
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6V12M12 12V18M12 12H18M12 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <p className="disclaimer-msg" style={{ marginTop: '8px', fontSize: '0.9rem', color: '#888' }}>
        <strong>
          If you have purchased the token via our payment gateway provider, please allow us up to 15 mins for your token to reflect.
        </strong>
      </p>
        </>
      )}
    </div>
  </div>
)}
     
{isModalOpen && (
  <div className="inline-section" onClick={() => setIsModalOpen(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="wizard-container">
        <div className="wizard-header">
          
          {/* <div className="price-timer">
            <span>Next price increase in</span>
            <div className="timer">
              <span>{formatTime(timeLeft.days)}d</span>
              <span>{formatTime(timeLeft.hours)}h</span>
              <span>{formatTime(timeLeft.minutes)}m</span>
              <span>{formatTime(timeLeft.seconds)}s</span>
            </div>
          </div> */}

                <div className="price-details"  style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                flexDirection: 'column',
                gap: '10px',
                padding: '20px',
              }}>
              <div>
                <span>Current price</span>
                <span>1 RZTO = ${exchangeRates?.RZTO?.toFixed(4)}</span>
              </div>
              {/* <div>
                <span>Next price</span>
                <span>1 RZTO = $0.00438</span>
              </div> */}
            </div>

          {/* <div className="price-info">
            <div className="raised-info">
              <span>USDT raised</span>
              <div className="progress-bar">
              <div className="progress" style={{ width: '100%' }}></div>
              <span>$1,165,000 / $1,165,000</span>
            </div>

            </div>

     
          </div> */}
        </div>

        <div className="tokens-info">
          <div className="tokens-section">
            <span>YOUR PURCHASED TOKENS</span>
            <span className="token-amount">{rizztoken}</span>
          </div>
          <div className="tokens-section">
            <span>YOUR STAKED TOKENS</span>
            <span className="token-amount">{totalStaked}</span>
          </div>
        </div>

           
       <p className="quick-buy-subtitle">Instant Confirmation Using Your Wallet</p>

             <div className="payment-method-selector">
         <div className="payment-option-container" style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
    {/* First row */}
    <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
      {/* ETH */}
      <button
        className={`payment-option ${paymentMethod === 'eth' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('eth');
          setSelectedPayment('ETH');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'eth' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.ETH}
            alt="ETH"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            ETH
          </div>
        </div>
      </button>

      {/* SOL */}
      <button
        className={`payment-option ${paymentMethod === 'sol' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('sol');
          setSelectedPayment('SOL');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'sol' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.SOL}
            alt="SOL"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            SOL
          </div>
        </div>
      </button>
    </div>

    {/* Second row */}
    <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
      {/* USDT */}
      <button
        className={`payment-option ${paymentMethod === 'usdt' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('usdt');
          setSelectedPayment('USDT');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'usdt' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.USDT}
            alt="USDT"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            USDT
          </div>
        </div>
      </button>

      {/* USDC */}
      <button
        className={`payment-option ${paymentMethod === 'usdc' ? 'active' : ''}`}
        onClick={() => {
          setPaymentMethod('usdc');
          setSelectedPayment('USDC');
        }}
        style={{
          flex: 1,
          padding: '12px',
          borderRadius: '8px',
          border: '1px solid #444',
          background: paymentMethod === 'usdc' ? '#4e44ce' : '#333',
          cursor: 'pointer',
          minWidth: '120px'
        }}
      >
        <div className="payment-option-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <img
            src={cryptoLogos.USDC}
            alt="USDC"
            style={{ height: '24px', width: '24px', borderRadius: '50%' }}
          />
          <div className="payment-option-title" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            USDC
          </div>
        </div>
      </button>
    </div>
  </div>

  {/* Other cryptos dropdown */}
  <button
    className={`payment-option ${paymentMethod === 'other' ? 'active' : ''}`}
    onClick={() => {
      setPaymentMethod('other');
      setSelectedPayment('');
    }}
    style={{
      width: '100%',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid #444',
      background: paymentMethod === 'other' ? '#4e44ce' : '#333',
      cursor: 'pointer',
      marginTop: '12px',
      marginBottom:'10px'
    }}
  >
    <div
      className="payment-option-content"
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        whiteSpace: 'nowrap',
      }}
    >
       <img
        src={cryptoLogos.BTC}
        alt="BTC"
        style={{ width: '24px', height: '24px', borderRadius: '50%' }}
      />
      <img
        src={cryptoLogos.BNB}
        alt="BNB"
        style={{ width: '24px', height: '24px', borderRadius: '50%' }}
      />
      <img
        src={cryptoLogos.LTC}
        alt="LTC"
        style={{ width: '24px', height: '24px', borderRadius: '50%' }}
      />
      <div
        className="payment-option-title"
        style={{
          fontSize: '16px',
          fontWeight: 'bold',
        }}
      >
        For Other Crypto Currencies
      </div>
    </div>
  </button>
     <div className="payment-section">
          {paymentMethod === 'other' && (
            <div style={{ marginBottom: '12px' }}>
              <select
                value={selectedPayment}
                onChange={(e) => setSelectedPayment(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '8px',
                  backgroundColor: '#333',
                  color: '#fff',
                  border: '1px solid #555',
                  fontSize: '14px',
                  marginTop:'15px'
                }}
              >
             <option value="">-- Select Currency --</option>
            {Object.keys(exchangeRates)
            .filter((currency) => !['RZTO', 'USDT', 'USDC', 'ETH','SOL'].includes(currency))
            .map((currency) => (
              <option key={currency} value={currency}>
                {currency === 'TRC20' ? 'USDT(TRC20)' : currency}
              </option>
            ))}
              </select>

              {minTransaction && (
                <div style={{ marginTop: '10px', color: 'yellow', fontSize: '14px' }}>
                  Minimum transaction: {minTransaction} {selectedPayment}
                </div>
              )}
            </div>
          )}

          <div className="form-group">
            <label>Amount in {selectedPayment || 'Currency'}</label>
            <input
              type="text"
              value={paymentAmount}
              onChange={handlePaymentAmountChange}
              placeholder="Enter amount"
              disabled={!selectedPayment}
            />
          </div>

          {selectedPayment && !['USDT', 'USDC'].includes(selectedPayment) && paymentAmount && (
            <div className="form-group">
              <label>Amount in USDT</label>
              <div className="usdt-amount">
                {calculateUsdtEquivalent().toFixed(2)} USDT
              </div>
            </div>
          )}

          {/* Promo code section */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'wrap'
            }}>
              <span style={{
                minWidth: '80px',
                color: '#fff',
                fontSize: '14px'
              }}>Promo Code</span>
              <div style={{
                display: 'flex',
                flex: '1',
                minWidth: '200px',
                gap: '8px'
              }}>
                <input
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Enter promo code"
                  style={{
                    flex: '1',
                    minWidth: '120px',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid rgb(59, 57, 57)',
                    background: '#333',
                    color: 'white',
                    fontSize: '14px'
                  }}
                />
                <button
                  onClick={applyPromoCode}
                  style={{
                    padding: '10px 16px',
                    whiteSpace: 'nowrap',
                    borderRadius: '8px',
                    border: 'none',
                    background: '#4e44ce',
                    color: 'white',
                    cursor: 'pointer',
                    fontWeight: '500',
                    fontSize: '14px'
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>

          {/* Promo result */}
          {extraToken > 0 && appliedPromo && (
            <div className="bonus-token-info" style={{color:'white', marginTop:'20px'}}>
              🎉 Promo code <strong>{appliedPromo.code}</strong> applied! You will receive <strong>{extraToken}</strong> bonus tokens!
            </div>
          )}

          <div className="form-group" style={{color:'white', marginTop:'20px'}}>
            <label>You will receive</label>
            <div className="receive-amount">
              { (parseFloat(calculateReceivedAmount().toString().replace(/,/g, '')) + extraToken
              ).toLocaleString()} RZTO
            </div>
          </div>
           {/* <p>You will receive RZTO token here: {walletAddress}</p> */}
             <div className="wallet-section">
                   {isConnected ? (
                   <>
                   <p className="wallet-address-container">
                     Connected Wallet Address : {walletAddress ? `${walletAddress.slice(0, 10)}...${walletAddress.slice(-10)}` : ''}
                   </p>
                     <button 
                       onClick={disconnect}
                               className="buy-button"
                     >
                       Disconnect Wallet
                     </button>
                     </>
                   ) : (
                     <div className="wallet-section" style={{
                       display: 'flex',
                       justifyContent: 'center',
                       marginTop: '20px',
                     }}>
                       {selectedPayment === 'SOL' ? (
                         <button 
                           onClick={handleConnect}
                               className="buy-button"
                         >
                           Connect a Solana-compatible wallet
                         </button>
                       ) : ['ETH', 'USDT', 'USDC'].includes(selectedPayment) ? (
                         <button 
                           onClick={() => modal.open('eip155')}
                               className="buy-button"
                         >
                           Connect an Ethereum-compatible wallet
                         </button>
                       ): (
                         ''
                       )}
                     </div>
                   )}
                   </div>
            <button
              className="buy-button"
              onClick={handlePayment}
            hidden={!isConnected && !['TRC20','BTC', 'BNB', 'ARB', 'POL', 'LTC', 'DOGE'].includes(selectedPayment)}
            >
              {buyTokenLoading ? 'Processing...' : 'Buy Tokens'}
            </button>
            {buyTokenLoading && (
          <div className="processing-notification">
            <div className="processing-content">
              <div className="loader"></div>
              <h3>Transaction Processing</h3>
              <p>Please wait, this may take a few moments...</p>
            </div>
          </div>
        )}
        </div>
     </div>

    {/* <div className="swap-section">
    <span>Select Payment Currency</span>

    <div style={{ marginBottom: '12px' }}>
    <select
    value={selectedPayment}
    onChange={(e) => setSelectedPayment(e.target.value)}
    style={{
      width: '100%',
      padding: '10px',
      borderRadius: '8px',
      backgroundColor: '#333',
      color: '#fff',
      border: '1px solid #555',
      fontSize: '14px',
    }}
  >
  <option value="">-- Select Currency --</option>
  {Object.keys(exchangeRates)
    .filter((currency) => currency !== 'RZTO')
    .map((currency) => (
      <option key={currency} value={currency}>
        {currency === 'TRC20' ? 'USDT(TRC20)' : currency}
      </option>
  ))}

  </select>

  {minTransaction && (
      <div style={{ marginTop: '10px', color: '#ccc', fontSize: '14px', color:'yellow' }}>
        Minimum transaction: {minTransaction} {selectedPayment}
      </div>
    )}

    </div>

  <div className="swap-row">
    <span>Amount in {selectedPayment || 'Currency'}</span>
    <div className="token-selector">
      <span className="receive-amount">
        <input
          type="text"
          value={paymentAmount}
          onChange={handlePaymentAmountChange}
          placeholder="Enter amount"
        />
      </span>
    </div>
  </div>

  {selectedPayment && selectedPayment !== 'USDT' && paymentAmount && (
    <div className="swap-row">
      <span>Amount in USDT</span>
      <div className="token-selector">
        <span className="receive-amount">
          {calculateUsdtEquivalent().toFixed(2)} USDT
        </span>
      </div>
    </div>
  )}

  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flexWrap: 'wrap'
    }}>
      <span style={{
        minWidth: '80px',
        color: '#888',
        fontSize: '14px'
      }}>Promo Code</span>
      <div style={{
        display: 'flex',
        flex: '1',
        minWidth: '200px',
        gap: '8px'
      }}>
        <input
          type="text"
          value={promoCode}
          onChange={(e) => setPromoCode(e.target.value)}
          placeholder="Enter promo code"
          style={{
            flex: '1',
            minWidth: '120px',
            padding: '10px 12px',
            borderRadius: '8px',
            border: '1px solid rgb(59, 57, 57)',
            background: '#333',
            color: 'white',
            fontSize: '14px'
          }}
        />
        <button
          onClick={applyPromoCode}
          style={{
            padding: '10px 16px',
            whiteSpace: 'nowrap',
            borderRadius: '8px',
            border: 'none',
            background: '#4e44ce',
            color: 'white',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '14px'
          }}
        >
          Apply
        </button>
      </div>
    </div>
  </div>

  {extraToken > 0 && appliedPromo && (
    <div className="bonus-token-info">
      🎉 Promo code <strong>{appliedPromo.code}</strong> applied! You will receive <strong>{extraToken}</strong> bonus tokens!
    </div>
  )}

  <div className="swap-row">
    <span>You will receive</span>
    <div className="token-selector">
      <span className="receive-amount">
        {(
          parseFloat(calculateReceivedAmount().toString().replace(/,/g, '')) + extraToken
        ).toLocaleString()} {selectedReceive}
      </span>
    </div>
  </div>
</div> */}
          {/* <button
          className="connect-button"
          onClick={disconnectPhantomWallet}
            disabled={walletLoading}
          >
            {walletLoading ? 'Disconnecting...' : 'Disconnect Wallet'}
          </button> */}
         {/* <button
           style={{ marginTop: '20px' }}
            className="swap-button"
            onClick={handlePayment}
          // disabled={!wallet.connected || buyTokenLoading || parseFloat(paymentAmount) <= 0}
        >
          {buyTokenLoading ? 'Processing...' : 'Buy Tokens'}
        </button> */}
      </div>
    </div>
  </div>
)}


{showPaymentModal && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Segoe UI, Roboto, sans-serif',
    padding: '1rem',
    zIndex: 9999,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch' 
  }}>
    <div style={{
      background: 'rgba(20, 20, 30, 0.95)',
      padding: 'clamp(1rem, 3vw, 1.5rem)',
      borderRadius: 'clamp(0.75rem, 2vw, 1rem)',
      width: '100%',
      maxWidth: 'min(500px, 90vw)',
      boxShadow: '0 0 20px rgba(0, 255, 200, 0.1)',
      color: '#fff',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      maxHeight: '90vh',
      overflowY: 'auto',
      margin: 'auto'
    }}>
      <h1 style={{ 
        fontSize: 'clamp(1.1rem, 4vw, 1.25rem)', 
        fontWeight: 600, 
        marginBottom: 'clamp(0.75rem, 2vw, 1rem)', 
        color: '#0ff' 
      }}>
        Pay with crypto token of your choice
      </h1>

      {/* <p style={{ 
        marginBottom: 'clamp(0.25rem, 1vw, 0.5rem)',
        fontSize: 'clamp(0.875rem, 3vw, 1rem)'
      }}>
        🎉 Your transaction has been initiated successfully
      </p>
      <p style={{ 
        fontWeight: 600, 
        marginBottom: 'clamp(0.5rem, 2vw, 0.75rem)',
        fontSize: 'clamp(0.875rem, 3vw, 1rem)'
      }}>
        🧾 Tracking ID: <span style={{ color: '#0ff' }}>{invoiceId}</span>
      </p>

      <p style={{ 
        fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', 
        color: '#aaa', 
        marginBottom: 'clamp(1rem, 3vw, 1.25rem)'
      }}>
        Save this Tracking ID. If there's a problem, use it to contact us.
      </p> */}

      <p style={{ 
        marginBottom: 'clamp(0.75rem, 2vw, 1rem)',
        fontSize: 'clamp(0.875rem, 3vw, 1rem)'
      }}>
        Send <span style={{ color: '#0ff', fontWeight: 'bold' }}>{paymentAmount} {currency.toUpperCase()}</span> to the address below.
      </p>

      <div style={{ 
        marginBottom: 'clamp(0.75rem, 2vw, 1rem)', 
        fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)'
      }}>
        RZTO WORTH: <strong style={{ color: '#0ff' }}>{rztoAmount}</strong>
      </div>

      <hr style={{ 
        border: 'none', 
        borderTop: '1px solid #333', 
        margin: 'clamp(0.75rem, 2vw, 1rem) 0' 
      }} />

      <div style={{ textAlign: 'center' }}>
        <img 
          src={qrCode} 
          alt="QR Code" 
          style={{
            width: 'clamp(120px, 50vw, 180px)',
            height: 'auto',
            borderRadius: 'clamp(0.25rem, 1vw, 0.5rem)',
            display: 'inline',
          }} 
        />
        <h2 style={{ 
          fontSize: 'clamp(0.875rem, 3vw, 1rem)', 
          fontWeight: 600, 
          marginTop: 'clamp(0.5rem, 2vw, 0.75rem)'
        }}>
          Scan address from wallet of your choice.  
        </h2>
        <h2 style={{ 
          fontSize: 'clamp(0.875rem, 3vw, 1rem)', 
          fontWeight: 600
        }}>
          OR  
        </h2>
        <h2 style={{ 
          fontSize: 'clamp(0.875rem, 3vw, 1rem)', 
          fontWeight: 600
        }}>
          Use following wallet address to send ( use copy icon to copy address )
        </h2>
        <p style={{ 
          fontSize: 'clamp(0.6875rem, 2.5vw, 0.8125rem)', 
          color: '#bbb', 
          marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
        }}>
          This address is for one-time use only. Your balance will show after network confirmation.
        </p>
      </div>

      <div style={{ marginBottom: 'clamp(0.75rem, 2vw, 1rem)' }}>
        <h3 style={{ 
          fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', 
          marginBottom: 'clamp(0.25rem, 1vw, 0.375rem)', 
          color: '#0ff' 
        }}>
          Wallet Address
        </h3>
        <div style={{
          backgroundColor: '#111',
          borderRadius: 'clamp(0.25rem, 1vw, 0.375rem)',
          padding: 'clamp(0.5rem, 1.5vw, 0.625rem)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          wordBreak: 'break-word',
          overflowWrap: 'break-word'
        }}>
          <code style={{ 
            fontFamily: 'monospace', 
            fontSize: 'clamp(0.6875rem, 2.5vw, 0.8125rem)', 
            flexGrow: 1 
          }}>
            {paymentAddress}
          </code>
          <button
            onClick={handleCopyAddress}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: 'clamp(0.875rem, 3vw, 1rem)',
              color: '#0ff',
              marginLeft: 'clamp(0.25rem, 1vw, 0.5rem)',
              flexShrink: 0
            }}
            title="Copy to clipboard"
          >
            {copiedAddress ? '✅' : '📋'}
          </button>
        </div>
      </div>

      <div style={{ marginBottom: 'clamp(0.75rem, 2vw, 1rem)' }}>
        <h3 style={{ 
          fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', 
          marginBottom: 'clamp(0.25rem, 1vw, 0.375rem)', 
          color: '#0ff' 
        }}>
          Payment Amount
        </h3>
        <div style={{
          backgroundColor: '#111',
          borderRadius: 'clamp(0.25rem, 1vw, 0.375rem)',
          padding: 'clamp(0.5rem, 1.5vw, 0.625rem)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <span style={{ fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)' }}>{paymentAmount}</span>
          <button
            onClick={handleCopy}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#0ff',
              fontSize: 'clamp(0.875rem, 3vw, 1rem)',
              marginLeft: 'clamp(0.25rem, 1vw, 0.5rem)',
              flexShrink: 0
            }}
            title="Copy payment amount"
          >
            {copied ? '✅' : '📋'}
          </button>
        </div>
      </div>

      <hr style={{ 
        border: 'none', 
        borderTop: '1px solid #333', 
        marginBottom: 'clamp(0.75rem, 2vw, 1rem)' 
      }} />

      <table style={{ 
        width: '100%', 
        fontSize: 'clamp(0.6875rem, 2.5vw, 0.8125rem)', 
        color: '#ccc', 
        marginBottom: 'clamp(1rem, 3vw, 1.25rem)' 
      }}>
        <tbody>
          <tr>
            <td style={{ 
              padding: 'clamp(0.25rem, 1vw, 0.375rem) 0', 
              fontWeight: 600 
            }}>
              Status
            </td>
            <td style={{ 
              padding: 'clamp(0.25rem, 1vw, 0.375rem) 0' 
            }}>
              {status}
            </td>
          </tr>
          <tr>
            <td style={{ 
              padding: 'clamp(0.25rem, 1vw, 0.375rem) 0', 
              fontWeight: 600 
            }}>
              Expires In
            </td>
            <td style={{ 
              padding: 'clamp(0.25rem, 1vw, 0.375rem) 0' 
            }}>
              {formatsTime(remainingTime)}
            </td>
          </tr>
        </tbody>
      </table>

      <p style={{
        fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)',
        color: '#ccc',
        marginBottom: 'clamp(1rem, 3vw, 1.25rem)',
        lineHeight: '1.5'
      }}>
        After you scan / send payment , you may hit "Payment done" below.<br />
        On successful payment , RZTO Tokens would be sent your wallet. Transfer may get delayed by few minutes due to network congestion.<br />
        For any support please email us at <span style={{ color: '#0ff' }}>info@rzto.io</span>
      </p>

      <button 
        onClick={closeModal} 
        style={{
          width: '100%',
          padding: 'clamp(0.625rem, 2vw, 0.75rem)',
          backgroundColor: '#0ff',
          color: '#000',
          fontWeight: 700,
          border: 'none',
          borderRadius: 'clamp(0.5rem, 1.5vw, 0.625rem)',
          cursor: 'pointer',
          transition: '0.3s ease',
          fontSize: 'clamp(0.875rem, 3vw, 1rem)',
          marginBottom: 'clamp(0.75rem, 2vw, 1rem)'
        }}
      >
        Payment done
      </button>

      <button 
        onClick={handleCancelTransaction} 
        style={{
          width: '100%',
          padding: 'clamp(0.625rem, 2vw, 0.75rem)',
          backgroundColor: 'transparent',
          color: '#ccc',
          fontWeight: 700,
          border: '1px solid #666',
          borderRadius: 'clamp(0.5rem, 1.5vw, 0.625rem)',
          cursor: 'pointer',
          transition: '0.3s ease',
          fontSize: 'clamp(0.875rem, 3vw, 1rem)'
        }}
      >
        Cancel
      </button>
    </div>
  </div>
)}
<style jsx>{`
        .quick-buy-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          padding: 20px;
        }
        
        .quick-buy-card {
          background: #1e1e1e;
          backdrop-filter: blur(10px);
          border-radius: 16px;
          padding: 30px;
          width: 100%;
          max-width: 500px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .quick-buy-title {
          color: #fff;
          text-align: center;
          margin-bottom: 10px;
          font-size: 24px;
        }
        
        .quick-buy-subtitle {
          color: rgba(255, 255, 255, 0.7);
          text-align: center;
          font-size: 20px;
          font-weight: bold;
        }
        
        .wallet-section {
          margin-bottom: 25px;
        }
        
        .connect-wallet-button {
          width: 100%;
          padding: 15px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .connect-wallet-button:hover {
          opacity: 0.9;
        }
        
        .connect-wallet-button:disabled {
          background: #666;
          cursor: not-allowed;
        }
        
        .wallet-connected {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(255, 255, 255, 0.1);
          padding: 12px 15px;
          border-radius: 8px;
          color: #fff;
        }
        
        .disconnect-button {
          background: rgba(255, 0, 0, 0.2);
          border: 1px solid rgba(255, 0, 0, 0.3);
          color: #ff6b6b;
          padding: 5px 10px;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .disconnect-button:hover {
          background: rgba(255, 0, 0, 0.3);
        }
        
        .price-display {
          display: flex;
          justify-content: center;
          gap: 8px;
          margin-bottom: 20px;
        }
        
        .current-price-label {
          color: rgba(255, 255, 255, 0.8);
        }
        
        .current-price-value {
          color: #fff;
          font-weight: 500;
        }
        
        .wallet-address-container {
          display: flex;
          flex-direction: column;
          color: #fff;
          background: rgba(255, 255, 255, 0.05);
          padding: 12px;
          border-radius: 8px;
        }
        
        .payment-option-container {
          display: flex;
          gap: 12px;
          margin-bottom: 12px;
          flex-wrap: wrap;
        }
        
        .payment-option {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          padding: 10px 15px;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 100px;
          color:white;
        }
        
        .payment-option:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        
        .payment-option.active {
          background: rgba(78, 68, 206, 0.2);
          border-color: #4e44ce;
        }
        
        .payment-option-content {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .payment-option-title {
          font-size: 18px;
          font-weight: bold;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-group label {
          display: block;
          color: #fff;
          margin-bottom: 8px;
          font-size: 14px;
        }
        
        .form-group select,
        .form-group input {
          width: 100%;
          padding: 12px 15px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
          font-size: 14px;
        }
        
        .form-group select:focus,
        .form-group input:focus {
          outline: none;
          border-color: #4e44ce;
        }
        
        .min-transaction {
          margin-top: 5px;
          color: #f1c40f;
          font-size: 12px;
        }
        
        .usdt-amount,
        .receive-amount {
          padding: 12px 15px;
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.05);
          color: #fff;
          font-size: 14px;
        }
        
        .buy-button {
          width: 100%;
          padding: 15px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 10px;
        }
        
        .buy-button:hover {
          opacity: 0.9;
        }
        
        .buy-button:disabled {
          background: #666;
          cursor: not-allowed;
        }
        
        .payment-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }
        
        .payment-modal {
          background: #1a1a2e;
          border-radius: 16px;
          padding: 25px;
          width: 90%;
          max-width: 450px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .payment-modal h2 {
          color: #fff;
          text-align: center;
          margin-bottom: 15px;
        }
        
        .payment-modal p {
          color: rgba(255, 255, 255, 0.8);
          text-align: center;
          margin-bottom: 15px;
        }
        
        .qr-code-container {
          display: flex;
          justify-content: center;
          margin: 20px 0;
        }
        
        .qr-code-container img {
          width: 180px;
          height: 180px;
          border-radius: 8px;
        }
        
        .payment-details {
          margin: 20px 0;
        }
        
        .detail-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          color: rgba(255, 255, 255, 0.8);
        }
        
        .address-box,
        .amount-box {
          display: flex;
          align-items: center;
          background: rgba(0, 0, 0, 0.3);
          padding: 8px 12px;
          border-radius: 6px;
        }
        
        .address-box code {
          word-break: break-all;
          margin-right: 10px;
        }
        
        .address-box button,
        .amount-box button {
          background: none;
          border: none;
          color: #4e44ce;
          cursor: pointer;
          font-size: 16px;
        }
        
        .modal-actions {
          display: flex;
          gap: 10px;
          margin-top: 20px;
        }
        
        .done-button {
          flex: 1;
          padding: 12px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
        }
        
        .cancel-button {
          flex: 1;
          padding: 12px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: transparent;
          color: white;
          font-weight: 600;
          cursor: pointer;
        }
        
        .disclaimer {
          margin-top: 20px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
          text-align: center;
        }
        
        .post-purchase-notification-top {
          position: fixed;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1000;
          animation: slideDown 0.3s ease-out;
          width: 90%;
          max-width: 500px;
        }
        
        .notification-content {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          border: 1px solid #4e44ce;
          border-radius: 12px;
          padding: 20px;
          width: 100%;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
          text-align: center;
          margin-top: 30px;
        }
        
        .notification-content h3 {
          color: #fff;
          margin-bottom: 10px;
          font-size: 18px;
        }
        
        .notification-content p {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 15px;
          font-size: 14px;
        }
        
        .notification-actions {
          display: flex;
          gap: 10px;
          justify-content: center;
        }
        
        .register-button {
          padding: 10px 20px;
          border-radius: 8px;
          border: none;
          background: linear-gradient(90deg, #4e44ce 0%, #35aee2 100%);
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 120px;
        }
        
        .register-button:hover {
          opacity: 0.9;
        }
        
        .close-button {
          padding: 10px 20px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: transparent;
          color: white;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 120px;
        }
        
        .close-button:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        
        @keyframes slideDown {
          from {
            transform: translate(-50%, -100px);
            opacity: 0;
          }
          to {
            transform: translate(-50%, 0);
            opacity: 1;
          }
        }

        .processing-notification {
          position: fixed;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 1000;
          animation: slideDown 0.3s ease-out;
          width: 90%;
          max-width: 500px;
        }

        .processing-content {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          border: 1px solid #4e44ce;
          border-radius: 12px;
          padding: 20px;
          width: 100%;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 30px;
        }

        .processing-content h3 {
          color: #fff;
          margin: 15px 0 10px;
          font-size: 18px;
        }

        .processing-content p {
          color: rgba(255, 255, 255, 0.8);
          margin-bottom: 0;
          font-size: 14px;
        }

        .loader {
          width: 50px;
          height: 50px;
          border: 4px solid rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          border-top-color: #4e44ce;
          margin: 0 auto;
          animation: spin 1s linear infinite;
        }
          .connect-wallet-button {
          padding: 10px 20px;
          background-color: #1e88e5;
          color: white;
          font-weight: bold;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          margin-top:20px;
        }
        .connect-wallet-button:hover {
          background-color: #1565c0;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>

    </>
    
  );
}

